import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import store from '../store'
import { mapActions } from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: {
      namespaced: true,
      state: {
        token: localStorage.getItem('token') || null,
        usuario: JSON.parse(localStorage.getItem('usuario')) || null,
        clienteStore: {},
        listFacturaStore: [], vistaPreviaStore: null,
        listMarcasStore: [],
        listModelosStore: [],
        listaProvedoresStore: [],
        documentosStore: {},
        notificacionesStore: [],
        storeBase64Cotizacion: '',
        storeBase64Contrato: '',
        objetoContrato: {},
        objetoValoresCotizacion: {
          precio: 0,
          anticipo: 0,
          seguro: 0,
          placas: 0,
          plazo: "12",
          valorres: 0
        },

        objetoPostCotizacion: {
          agente: '',
          cliente: '',
          vehiculo: '',
          precio: '',
          anticipo: 0,
          seguro: 0,
          // total: 0,
          plazo: '',
          preciototal: 0,
          rentamensual: 0,
          iva: 0,
          rentamensualtotal: 0,
          comisionxapertura: 0,
          depgarantiarentaadelantada: 0,
          pagoinicialtotal: 0,
          valorresidual: 0,
          notaVresidual: ""
        },

      },
      mutations: {
        setToken(state, token) {
          state.token = token;
          localStorage.setItem('token', token);
        },
        setUsuario(state, usuario) {
          state.usuario = usuario;
          localStorage.setItem('usuario', JSON.stringify(usuario));
        },
        clearAuth(state) {
          state.token = null;
          state.usuario = null;
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');
        },
        setDocumento(state, { campo, documento }) {
          if (state.documentosStore && state.documentosStore[campo]) {
            state.documentosStore[campo] = { ...documento };
          }
        }
      },
      actions: {
        guardarToken({ commit }, token) {
          commit('setToken', token);
        },
        guardarUsuario({ commit }, usuario) {
          commit('setUsuario', usuario);
        },
        cerrarSesion({ commit }) {
          commit('clearAuth');
        }
      },
      getters: {
        isAuthenticated: state => !!state.token,
        usuario: state => state.usuario
      }
    }
  }
})
